import { inject } from '@angular/core';
import { StorageService } from '@cosmos/angular/utils';
import { TranslateService } from '@ngx-translate/core';

export function initConfig(): any {
  return () => {
    const storageService = inject(StorageService);
    const translate = inject(TranslateService);

    const body = document.querySelector('html');
    if (
      storageService.getItem('theme') === 'dark' ||
      (storageService.getItem('theme') === null &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    )
      body.classList.add('dark');

    // const body = document.getElementsByTagName("body")[0];
    // if(
    //   storageService.getItem('theme') === 'light' ||
    //   (storageService.getItem('theme') === null && window.matchMedia("(prefers-color-scheme: light)").matches)
    // ) body.classList.add('light-theme');

    if (storageService.getItem('language'))
      translate.use(storageService.getItem('language'));
    if (!storageService.getItem('groupDisplay'))
      storageService.setItem('groupDisplay', 'table');

    const sizeMap: Record<string, string> = { small: '13px', default: '14px', large: '16px' };
    const savedSize = storageService.getItem('textSize') || 'default';
    body.style.fontSize = sizeMap[savedSize] ?? '14px';
  };
}
